/** Current UTC calendar month as `YYYY-MM` (matches usage API default month). */
export function monthNowUtc(now: Date = new Date()): string {
  const y = now.getUTCFullYear();
  const m = String(now.getUTCMonth() + 1).padStart(2, "0");
  return `${y}-${m}`;
}
